'use strict';

var $ = require('jquery');
var _ = require('lodash');
var JQXGridColumnEditorsService = function JQXGridColumnEditorsService($filter, momentService, gridDropdownPopulateService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  var SELECT_ALL_ITEM = 'Select All';
  function initDateTimeEditor(editor, row, cellvalue) {
    var dateInput = editor.find('.jqx-datetimeinput');
    var dateElement = dateInput.length > 0 ? dateInput : $('<div/>').prependTo(editor);
    dateElement.jqxDateTimeInput({
      allowNullDate: false,
      formatString: row.dateRowParameters.editFormatString,
      width: '100%',
      height: '100%',
      placeHolder: 'Select date',
      value: momentService.of(cellvalue, row.dateRowParameters.momentConfig).value.toDate()
    });
  }
  function initMaskInput(editor, row, cellvalue) {
    editor.jqxMaskedInput({
      mask: row.customControlMask
    });
    editor.jqxMaskedInput('maskedValue', row.customControlMaskFunc(cellvalue));
  }
  function initDropdownEditor(editor, dropdownValues, row, datafield) {
    editor.jqxDropDownList({
      isGridEditable: true,
      filterable: true,
      searchMode: 'containsignorecase',
      source: dropdownValues,
      selectedIndex: dropdownValues.indexOf(_.toString(row[datafield])),
      autoDropDownHeight: dropdownValues.length < 8
    }).on('open', function () {
      editor.jqxDropDownList('clearFilter');
    });
  }
  function initAutoCompleteEditor(editor, dropdownValues, row, cellvalue) {
    editor.jqxInput({
      searchMode: 'containsignorecase',
      source: dropdownValues,
      minLength: 1
    });
  }
  function initMultiAutoCompleteEditor(editor, dropdownValues, row, cellvalue) {
    editor.jqxInput({
      searchMode: 'containsignorecase',
      source: function source(query, response, itemValue) {
        var item = query.split(',').pop();
        editor.jqxInput({
          query: item
        });
        response(dropdownValues);
      },
      renderer: function renderer(itemValue, inputValue) {
        var terms = inputValue.split(',');
        terms.pop();
        terms.push(itemValue);
        var value = terms.join(',');
        return value;
      }
    });
  }
  function initCustomEditor(editor, row, cellvalue, columnType, jqxGridColumnId, loadedData, datafield, prependEmptyValue, fieldVariant) {
    if (columnType === 'dropdownlist' || columnType === 'autocomplete' || columnType === 'multiAutocomplete' || columnType === 'multidropdownlist' || row.customControlType === 'dropdownlist' || row.customControlType === 'multidropdownlist') {
      var dropdownValues = gridDropdownPopulateService.getDropdownValues(datafield, jqxGridColumnId, row, loadedData, fieldVariant, columnType);
      if (prependEmptyValue) {
        dropdownValues.unshift('');
      }
      if (columnType === 'multidropdownlist' || row.customControlType === 'multidropdownlist') {
        initMultiSelectDropdownEditor(editor, dropdownValues, row, datafield);
      } else if (columnType === 'autocomplete') {
        initAutoCompleteEditor(editor, dropdownValues, row, cellvalue);
      } else if (columnType === 'multiAutocomplete') {
        initMultiAutoCompleteEditor(editor, dropdownValues, row, cellvalue);
      } else {
        initDropdownEditor(editor, dropdownValues, row, datafield);
      }
    } else if (row.customControlType === 'maskedinput') {
      initMaskInput(editor, row, cellvalue);
    } else if (row.dateRowParameters) {
      initDateTimeEditor(editor, row, cellvalue);
    } else if (editor[0] && columnType === 'textbox') {
      editor[0].value = cellvalue.replaceAll('&amp;', '&');
    }
  }
  function initMultiSelectDropdownEditor(editor, dropdownValues, row, datafield) {
    dropdownValues = _.clone(dropdownValues);
    if (dropdownValues.indexOf(SELECT_ALL_ITEM) === -1) {
      dropdownValues.unshift(SELECT_ALL_ITEM);
    }
    editor.jqxDropDownList({
      isGridEditable: true,
      source: dropdownValues,
      selectedIndex: -1,
      autoDropDownHeight: dropdownValues.length < 8,
      checkboxes: true
    });
    var values = row[datafield] && row[datafield].split(',') || [];
    values.forEach(function (value) {
      editor.jqxDropDownList('checkItem', value);
    });
    if (values.length === dropdownValues.length - 1) {
      editor.jqxDropDownList('checkItem', SELECT_ALL_ITEM);
    }
    editor.on('checkChange', function (evt) {
      if (evt.args && evt.args.value === SELECT_ALL_ITEM) {
        var isChecked = evt.args.checked;
        var fn = isChecked ? 'checkAll' : 'uncheckAll';
        editor.jqxDropDownList(fn);
      }
    });
  }
  function getValueFromDateEditor(editor, row) {
    var dateField = editor.find('div');
    var dateObject = dateField.jqxDateTimeInput('getDate')[0][0][0][0][0];
    var filterMoment = momentService.of(dateObject, row.dateRowParameters.momentConfig).startOf('day');
    return rmMomentFormat(filterMoment, row.dateRowParameters.saveFormatString);
  }
  function getValueFromDropdownEditor(editor, value) {
    var selectedIndex = editor.jqxDropDownList('selectedIndex');
    var item = editor.jqxDropDownList('listBox').getVisibleItem(selectedIndex);
    return item ? item.value || value : value;
  }
  function getValueFromEditor(editor, row, value) {
    if (row.dateRowParameters) {
      value = getValueFromDateEditor(editor, row);
    } else if (row.customControlType === 'dropdownlist') {
      value = getValueFromDropdownEditor(editor, value);
    }
    return value;
  }
  return {
    initCustomEditor: initCustomEditor,
    getValueFromEditor: getValueFromEditor
  };
};
JQXGridColumnEditorsService.$inject = ['$filter', 'MomentService', 'GridDropdownPopulateService'];
module.exports = JQXGridColumnEditorsService;